<template>
    <div class="pb-5">
        <b-button
            :to="{ name: 'ParticipatePreface', query: { ...$route.query}}"
            class="px-3 text-left border-0 fw-500"
            :variant="home_active_sytle === true ? 'icon-blue' : 'icon-light'"
            style="height: 48px; border-radius: 0"
            block
            >
            <fa icon="map-marker-alt" class="mr-1"/> {{ $t('안내') }}
        </b-button> 
        
        <template v-if="template_in_progress_loaded === true && custom_template_loaded === true">
            <b-list-group v-for="(lv1,idx) in new_question_list"
                :key="lv1.id"
                :class="home_active_sytle === false ? 'question-active' : ''"
                class="mb-1"
                >
                <div class="pl-3 py-1 fw-500 category1s"
                    :aria-controls="`cat-${idx}`"
                    @click="toggleList(idx)"
                    >
                    <fa :icon="visible[idx] === true ? 'caret-down' : 'caret-right'" class="mr-1"></fa>
                    {{ showTranslation(lv1.category1_name, lv1.category1_name_e, lv1.category1_name_c) }}
                </div> 
                <b-collapse :id="`cat-${idx}`" v-model="visible[idx]">
                    <b-list-group-item v-for="lv3 in lv1.category3"
                        :key="lv3.question_code"
                        class="d-flex justify-content-between"
                        :class="[$route.params.question_code == lv3.question_code ? `active`: '', 'category3s']"
                        @click="pageGo(lv3)"
                        >
                        {{ showTranslation(lv3.question_name, lv3.question_name_e, lv3.question_name_c) }}
                        <span v-if="lv3.is_completed === 'true'" v-b-tooltip.hover :title="$t('답변 완료')">
                            <fa style="width:0.8rem;" :icon="['fas', 'square']" class="mr-1"></fa>
                        </span>
                        <span v-else v-b-tooltip.hover :title="$t('답변 작성중')" class="gray-550">
                            <fa style="width:0.8rem;" :icon="['far','square']" class="mr-1"></fa>
                        </span>
                    </b-list-group-item>
                </b-collapse>
            </b-list-group>
            <!-- <template v-if="$i18n.locale=='ko'">
                <b-button @click="goTaxonomyCheck" class="px-3 text-left border-0 border-top border-color-gray-300 fw-500" block :variant="is_active=='taxonomy'?'blue':'icon-light'" :style="home_active_sytle==true?'color:#494949!important;':''" style="border-radius: 0"><fa icon="leaf" class="mr-1"/> 녹색경제활동분류체계 여부 </b-button> 
            </template> -->
            
        </template>
        <template v-else>    
            <div class="px-3">
                <b-skeleton animation="wave" width="85%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="55%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="85%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
            </div>
        </template>           
        <hr class="border-0 pb-5">
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'QuestionList',
    data () {
        return {
            is_active: 'false',
            is_sidebar_collapsed: false,
            tree_key: Math.floor(Math.random() * 100000000), // 21918481, //random number
            home_active_sytle: true,
            visible: [true, true, true, true, true, true]
        };
    },
    computed: {
        // ...mapState(['company_id', 'view_mode', 'campaign_in_progress', 'template_in_progress','template_in_progress_loaded', 'question_in_progress']),
        ...mapState(['view_mode', 'template_in_progress','template_in_progress_loaded']),
        // ...mapState('industry_campaigns', ['custom_project_code', 'custom_template', 'custom_template_loaded']),
        ...mapState('industry_campaigns', ['custom_template_loaded']),
        company_id () {
            return this.$route.query.cpn;
        },
        template_code() {
            return this.template_in_progress.template_code;
        },
        template_contents() {
            return this.template_in_progress.template_contents;
        },
        new_question_list(){
            let new_list = [];
            // console.log(this.template_contents);
            this.template_contents.forEach( x=> {
                let new_obj = {};
                new_obj.category1_name = x.question_name;
                new_obj.category1_name_e = x.question_name_e;
                new_obj.category1_name_c = x.question_name_c;
                new_obj.category3 = [];
                x.children.forEach(y => {
                    y.children.forEach(z => new_obj.category3.push(z));
                });
                new_list.push(new_obj);
            });
            this.visible = new_list.map(() => true);
            return new_list;
        }
    },
    watch: {
        $route:{
            immediate: true,
            handler (to) {
                if (to.path.includes('/questions')) {
                    this.home_active_sytle = false;
                } else if (to.name === 'ParticipatePreface') {
                    this.home_active_sytle = true;
                    this.is_active = '';
                }
            }
        }
    },
    created () {
        this.$on('move-next-question', this.handleMoveNextQuestion);
        this.$on('refresh-tree', this.refreshTree); // from Question or Make Progress Complete All
    },
    mounted() {
        this.$EventBus.$on('Questions-pipeline_overlay_question_clicked', this.pageGo);
    },
    methods: {
        async pageGo (category3) {
            this.is_active = category3.question_code;
            if (this.$route.params.question_code === category3.question_code) return; // 같은 문항 재클릭 시 입력 중 내용 보존
            let temp_question = {...category3};
            if (typeof(category3.question_contents) === 'string') {
                // string 형태로 가지고 있는 것 parsing 해야함
                temp_question.question_contents = JSON.parse(category3.question_contents);
            }
            this.$store.commit('update_question_in_progress', temp_question);

            const { pc, cmp, cpn, cpnm } = this.$route.query;
            let question_code = temp_question.question_code,
                company_id = cpn,
                campaign_id = cmp;

            try {
                await this.$store.dispatch('questions/readSubs', {
                    code: question_code,
                    contents: temp_question.question_contents,
                    company_id, campaign_id,
                    path: 'question-list'
                });
            } catch (error) {
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t('문항을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            }

            if (this.$route.params.question_code !== temp_question.question_code) {
                this.$nextTick( () => {
                    this.$router.push({
                        name: 'Questions',
                        query: { pc, cmp, cpn, cpnm },
                        params: {
                            question_code: temp_question.question_code,
                        }
                    });
                });
            }
        },
        // goTaxonomyCheck(){
        //     this.is_active = 'taxonomy'
        //     this.$router.push({name:'TaxonomyCheck'})
        // },
        toggleList(idx){
            if(this.visible[idx]==true){
                this.visible.splice(idx, 1, false);
            }
            else this.visible.splice(idx, 1, true);
        },
        handleMoveNextQuestion(new_question_code) {
            this.is_active = new_question_code;
        },
        refreshTree(){
            this.tree_key += 10;
        }
        // clickProgressRate(){            
        //     this.$router.push({name:'Progress'})
        // }
    }
};
</script>

<style scoped>
.category1s{
    /* background: linear-gradient(90deg, var(--gray-300), var(--gray-200)); */
   border-bottom: 1px solid var(--gray-300);

}
.category3s{
    border: 0;
    border-radius: 0;
    letter-spacing: -0.2px;
    cursor: pointer;
    background-color: var(--gray-200);
    font-size: 0.9rem;
    color: var(--gray-600);
    padding: 0.25rem 1rem 0.25rem 1.75rem ;
}
.category3s:hover{
    background-color: var(--gray-300);
}

.question-active .category1s {
    color: var(--gray-100);
    border-bottom: 1px solid var(--gray-400);
    font-weight: 400;
}

.question-active .category3s{
    color: var(--gray-300);
    background-color: var(--gray-650);
    font-weight: 300;
}
.question-active .node-level-1:hover {
    color: var(--gray-50);
    border-bottom: 1px solid var(--gray-400);
}
.question-active .category3s:hover{
    background-color: var(--gray-700);
    color: var(--gray-100);
}
.question-active .node-level-1-active,
.question-active .category3s.active,
.question-active .node-level-3-active,
.question-active .node-level-4-active {
    background-color: var(--blue);
    color: var(--gray-100);
}
.question-active .node-level-1-active:hover,
.question-active .category3s.active:hover,
.question-active .node-level-3-active:hover,
.question-active .node-level-4-active:hover {
    background-color: var(--blue5);
    color: var(--gray-100);
}

[id^='cat'] > .list-group-item.active {
    background-color: var(--blue);
    border: 0;
}

.print-aside{
    top: 0;
    right:0; 
    margin-right:-44px;
    z-index: 1;
}
.print-aside:hover{
    top: 0;
    right:0; 
    margin-right:-195px;
}
</style>
